import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BoldTextCssClassClass;
function BoldTextCssClass() {
  if (BoldTextCssClassClass === VOID) {
    class $ {
      constructor() {
        BoldTextCssClass_instance = this;
        var styleNode = document.createElement('style');
        styleNode.innerHTML = '.inlineKeyValue strong {\n    font-weight: bold !important\n}';
        var tmp0_safe_receiver = document.head;
        if (tmp0_safe_receiver == null)
          null;
        else
          tmp0_safe_receiver.appendChild(styleNode);
      }
    }
    initMetadataForObject($, 'BoldTextCssClass');
    BoldTextCssClassClass = $;
  }
  return BoldTextCssClassClass;
}
var BoldTextCssClass_instance;
function BoldTextCssClass_getInstance() {
  if (BoldTextCssClass_instance === VOID)
    new (BoldTextCssClass())();
  return BoldTextCssClass_instance;
}
function get_boldStrongTag(_this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
  var prev = _this__u8e3s4.bbb_1;
  var tmp = _this__u8e3s4;
  tmp.bbb_1 = (_this__u8e3s4) => {
    var tmp0_safe_receiver = prev;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(_this__u8e3s4);
    BoldTextCssClass_getInstance();
    _this__u8e3s4.tb5_1.hb4_1.v('inlineKeyValue');
    return Unit_instance;
  };
  Companion_getInstance();
  return Companion_getInstance();
}
//region block: exports
export {
  get_boldStrongTag as get_boldStrongTag3a2aqno8aede0,
};
//endregion

//# sourceMappingURL=modifiers.mjs.map
